import { MessageCircle, Mail, Clock } from "lucide-react";
import { Logo } from "./Logo";
import { Reveal } from "./Reveal";

const Item = ({ icon: Icon, label, value, href, testId }) => {
  const body = (
    <>
      <Icon className="h-5 w-5 text-volt" />
      <span className="font-mono text-xs uppercase tracking-[0.2em] text-zinc-400">{label}</span>
      <span className="font-display text-lg text-paper md:text-xl">{value}</span>
    </>
  );
  return href ? (
    <a data-testid={testId} href={href} target="_blank" rel="noreferrer" className="flex flex-col gap-2 transition-opacity hover:opacity-80">{body}</a>
  ) : (
    <div data-testid={testId} className="flex flex-col gap-2">{body}</div>
  );
};

export const Footer = ({ settings }) => (
  <footer id="kontak" data-testid="site-footer" className="relative mt-24 overflow-hidden border-t border-white/[0.07] pt-20">
    <div className="mx-auto max-w-[1400px] px-5 md:px-10">
      <Reveal>
        <h2 className="max-w-3xl font-display text-4xl font-bold leading-[1] tracking-tight text-paper md:text-6xl">Ada pertanyaan? <span className="text-volt">Hubungi CS.</span></h2>
      </Reveal>
      <div className="mt-14 grid grid-cols-1 gap-10 sm:grid-cols-3">
        <Item testId="contact-whatsapp" icon={MessageCircle} label="WhatsApp" value={settings.whatsapp ? `+${settings.whatsapp}` : "[Nomor WhatsApp CS]"} href={settings.whatsapp ? `https://wa.me/${settings.whatsapp}` : null} />
        <Item testId="contact-email" icon={Mail} label="Email" value={settings.email || "[Email CS]"} href={settings.email ? `mailto:${settings.email}` : null} />
        <Item testId="contact-hours" icon={Clock} label="Jam layanan" value={settings.hours || "[Jam operasional]"} />
      </div>
      <div className="mt-20 flex flex-col justify-between gap-6 border-t border-white/[0.07] py-8 md:flex-row md:items-center">
        <Logo testId="footer-logo" />
        <p className="max-w-lg text-sm text-zinc-400">Tidak menerima pulsa ilegal seperti penipuan, cloning SIM, judi online, atau hasil bug.</p>
        <p data-testid="footer-copyright" className="text-sm text-zinc-400">Copyright © 2021 BagiPulsa. All Rights Reserved.</p>
      </div>
      <div className="flex flex-wrap gap-x-8 gap-y-3 pb-10 text-sm text-zinc-300">
        <a data-testid="footer-link-blog" href="/blog" className="link-line hover:text-paper">Blog</a>
        <a data-testid="footer-link-privacy" href="/privacy-policy" className="link-line hover:text-paper">Privacy Policy</a>
        <a data-testid="footer-link-terms" href="/syarat-ketentuan" className="link-line hover:text-paper">Terms and Conditions</a>
      </div>
    </div>
    <p aria-hidden="true" className="pointer-events-none select-none whitespace-nowrap text-center font-display text-[14vw] font-bold leading-[0.9] tracking-[-0.06em] text-outline opacity-60 pb-6">bagipulsa</p>
  </footer>
);
